import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormDialogTemplate } from '../form-dialog/form-dialog.template';

@Injectable()
export class PanelbarService {

    formDialog: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private dialogStack: FormDialogTemplate[] = [];

    expanded: any[] = [];

    constructor() { }

    openDialog(template: FormDialogTemplate) {
        if (template) this.dialogStack.push(template);
        this.formDialog.next(template);
    }

    closeDialog() {
        this.dialogStack.pop();
        this.openDialog(this.dialogStack.pop());
    }

    addExpandPanelbar(id: string) {
        if (!this.expanded.some(x => x === id)) this.expanded.push(id);
    }


    removeExpandPanelbar(id: string) {
        const index = this.expanded.indexOf(this.expanded.find(x => x === id));
        if (index > -1) this.expanded.splice(index, 1);
    }


}
